import { DEFAULT_LIMIT, fetchAllCursorPages, schedulingDelete, schedulingGet, schedulingPost, schedulingPut } from "./client";

export function listAvailability({
  organizationRef,
  availabilityId,
  scheduleId,
  serviceCategoryId,
  startsAt,
  endsAt,
  active,
  manualOnly,
  cursor,
  limit = DEFAULT_LIMIT,
  signal,
  consistency,
}) {
  return schedulingGet("availability", {
    organizationRef,
    availabilityId,
    scheduleId,
    serviceCategoryId,
    startsAt,
    endsAt,
    active,
    manualOnly,
    cursor,
    limit,
  }, { signal, consistency });
}

export async function listAllAvailability(params) {
  return fetchAllCursorPages({ itemsKey: "availability", signal: params.signal,
    fetchPage: async cursor => {
      const response = await listAvailability({ ...params, cursor });
      return response?.availability && !Array.isArray(response.availability) ? { ...response, availability: [response.availability] } : response;
    } });
}

export function createAvailability(body) {
  return schedulingPost("availability", body);
}

export function updateAvailability(body) {
  return schedulingPut("availability", body);
}

export function deactivateAvailability({ organizationRef, availabilityId }) {
  return schedulingDelete("availability", { organizationRef, availabilityId });
}

export { fetchAllCursorPages };
